
export default {
  props: {
    products: {
      type: Array,
      required: true,
    },
  },

  methods: {
    sum() {
      return this.products.reduce((sum, product) => {
        return sum + product.price
      }, 0)
    },
  },
}
